export default __webpack_public_path__ + "static/media/logo.81cc7e4a.svg";